// src/support/supportApi.ts
import { apiClient } from "@maat/api-base";
var supportApi = {
  // ── Help center (public) ──
  listHelpCategories: async (params = {}) => {
    return apiClient.get("/main/api/support/categories", { params });
  },
  listHelpArticles: async (params = {}) => {
    return apiClient.get("/main/api/support/articles", { params });
  },
  getHelpArticle: async (slug) => {
    return apiClient.get(`/main/api/support/articles/${slug}`);
  },
  listFaqs: async (params = {}) => {
    return apiClient.get("/main/api/support/faqs", { params });
  },
  // ── Tickets (authenticated user) ──
  createTicket: async (data) => {
    return apiClient.post("/main/api/support/tickets", data);
  },
  getTicket: async (id) => {
    return apiClient.get(`/main/api/support/tickets/${id}`);
  },
  // Replying is not a support-service call any more — the thread is a chat
  // conversation (`ticket.conversation_id`), so clients send through
  // @maat/api-chat and chat tells this service via its outbox.
  // ── Callbacks (authenticated user) ──
  createCallback: async (data) => {
    return apiClient.post("/main/api/support/callbacks", data);
  },
  listMyCallbacks: async () => {
    return apiClient.get("/main/api/support/callbacks");
  },
  // ── Admin: tickets ──
  adminListTickets: async (params = {}) => {
    return apiClient.get("/main/api/admin/support/tickets", { params });
  },
  adminTicketStats: async () => {
    return apiClient.get("/main/api/admin/support/tickets/stats");
  },
  adminGetTicket: async (id) => {
    return apiClient.get(`/main/api/admin/support/tickets/${id}`);
  },
  adminUpdateTicket: async (id, data) => {
    return apiClient.patch(`/main/api/admin/support/tickets/${id}`, data);
  },
  // ── Admin: articles ──
  adminListArticles: async (params = {}) => {
    return apiClient.get("/main/api/admin/support/articles", { params });
  },
  adminCreateArticle: async (data) => {
    return apiClient.post("/main/api/admin/support/articles", data);
  },
  adminGetArticle: async (id) => {
    return apiClient.get(`/main/api/admin/support/articles/${id}`);
  },
  adminUpdateArticle: async (id, data) => {
    return apiClient.patch(`/main/api/admin/support/articles/${id}`, data);
  },
  adminDeleteArticle: async (id) => {
    return apiClient.delete(`/main/api/admin/support/articles/${id}`);
  },
  // ── Admin: categories (read-only — a fixed, seeded lookup) ──
  adminListCategories: async () => {
    return apiClient.get("/main/api/admin/support/categories");
  },
  // ── Admin: FAQs ──
  adminListFaqs: async () => {
    return apiClient.get("/main/api/admin/support/faqs");
  },
  adminCreateFaq: async (data) => {
    return apiClient.post("/main/api/admin/support/faqs", data);
  },
  adminUpdateFaq: async (id, data) => {
    return apiClient.patch(`/main/api/admin/support/faqs/${id}`, data);
  },
  adminDeleteFaq: async (id) => {
    return apiClient.delete(`/main/api/admin/support/faqs/${id}`);
  },
  // ── Admin: callbacks ──
  adminListCallbacks: async (params = {}) => {
    return apiClient.get("/main/api/admin/support/callbacks", { params });
  },
  adminCallbackStats: async () => {
    return apiClient.get("/main/api/admin/support/callbacks/stats");
  },
  adminUpdateCallback: async (id, data) => {
    return apiClient.patch(`/main/api/admin/support/callbacks/${id}`, data);
  }
};

export {
  supportApi
};
